import PaypalPayment from './PaypalPayment.vue';

export default PaypalPayment;
